<template>
    <Layout :content-class="'content--faq'">
        <div class="content__title-wrap">
            <h1 class="content__title">FAQ</h1>
        </div>
        <Spinner v-if="loading" class="spinner--gray" />
        <div class="faq-page">
            <AccordionList>
                <Accordion v-for="(q, index) in faq" :key="index" :item-id="index">
                    <template #head>
                        <div class="faq-page__title accordion__title">
                            {{ q.question }}
                        </div>
                    </template>
                    <template #content>
                        <div class="static-content" v-html="q.answer"></div>
                    </template>
                </Accordion>
            </AccordionList>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { Accordion, AccordionList } from '@speechki-frontend/shared/ui/Accordion';

export default {
    name: 'FaqPage',
    components: {
        Layout,
        Accordion,
        AccordionList,
    },
    data() {
        return {
            loading: false,
            faq: [],
        };
    },
    async created() {
        this.loading = true;
        const postfix = this.$i18n.locale === 'eng' ? '-en' : '';
        this.faq = await this.$http.get(`/api/v1/faq/?ordering=-sort&topic__slug=common${postfix}`);
        this.loading = false;
    },
};
</script>
